// map of style urls to the first waterbody layer id
// use this to re-order user layers beneath lakes/streams, etc.
const waterLayers = new Map();
waterLayers.set('mapbox://styles/mapbox/basic-v9', 'waterway');
waterLayers.set('mapbox://styles/mapbox/bright-v9', 'waterway');
waterLayers.set('mapbox://styles/mapbox/light-v9', 'waterway-river-canal');
waterLayers.set('mapbox://styles/mapbox/dark-v9', 'waterway-river-canal');
waterLayers.set('mapbox://styles/mapbox/satellite-v9', null);

/**
 * get the first waterbody layer for a given mapbox style
 * @param  {String} styleUrl mapbox style url
 * @return {String|null}     map layer id, or null
 */
export default function waterLayer(styleUrl) {
    return waterLayers.get(styleUrl);
}



// WEBPACK FOOTER //
// ./src/functions/waterLayer.js